import { render, staticRenderFns } from "./BatchOverheadCost.vue?vue&type=template&id=52eee6c0&scoped=true"
import script from "./BatchOverheadCost.vue?vue&type=script&lang=ts"
export * from "./BatchOverheadCost.vue?vue&type=script&lang=ts"
import style0 from "./BatchOverheadCost.vue?vue&type=style&index=0&id=52eee6c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52eee6c0",
  null
  
)

export default component.exports